const index = () => import(/* webpackChunkName: "herb" */ './Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/major/v2019/index',
      name: 'majorV2019Index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/major/v2019/router.js